import { Add } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, TextField, Typography } from '@mui/material';
import { Container } from '@mui/system';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { AppModels, AppState, ContactAttrs, brandNewContact, contactSelector, contactSlice, saveModel } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { useSession } from '../../libraries/SessionProvider';
import { appStore } from '../../store';
import { MasterViewPage } from '../MasterPage';
import { AddContact } from './AddContact';

export const Contacts = () => {
    return <MasterViewPage>
        <MainSimpleViewLoader
            path='contact/list'>
            <LoadedContacts />
        </MainSimpleViewLoader>
    </MasterViewPage>;
};

const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
        field: 'firstName',
        headerName: 'Prénom',
        flex: 1,
    },
    {
        field: 'lastName',
        headerName: 'Nom',
        flex: 1
    },
    {
        field: 'tel',
        headerName: 'Tél.',
        renderCell: (params) => {
            return <Typography>{params.value}</Typography>;
        },
        flex: 1
    },
    {
        field: 'cell',
        headerName: 'Cell.',
        renderCell: (params) => {
            return <Typography>{params.value}</Typography>;
        },
        flex: 1
    },
    {
        field: 'email',
        headerName: 'Courriel',
        renderCell: (params) => {
            return <Typography component='a' target='_blank' href={params.value ? 'mailto://' + params.value : undefined}>{params.value}</Typography>;
        },
        flex: 1
    },
];

const LoadedContacts = () => {
    const contacts = useSelector((state: AppState) => contactSelector.selectAll(state));
    const navigate = useNavigate();
    const { isSuperAdmin } = useSession();

    const [createContact, setCreateContact] = React.useState(false);
    const [quickCreating, setQuickCreating] = React.useState(false);
    const [newContactName, setNewContactName] = React.useState('');


    const quickCreate = async () => {

        if (newContactName !== '') {
            setQuickCreating(true);
            const split: string[] = newContactName.split(' ').reduce((acc: string[], curr) => {
                if (curr.trim()) {
                    acc.push(curr.trim());
                }
                return acc;
            }, []);

            const newContact: ContactAttrs = {
                ...brandNewContact,
                cell: '',
                code: '',
                email: null,
                firstName: split[0],
                lastName: split.splice(1).join(' ') ?? '',
                imageFileId: null,
                image: null,
                locationId: null,
                name: '',
                relations: [],
                tel: null,
                title: '',
                telPoste: null,
                onSiteContact: null
            };
            const response = await saveModel(AppModels.contacts, newContact);
            appStore.dispatch(contactSlice.actions.addOne(response));
            setNewContactName('');
            setQuickCreating(false);
        }
    };

    return <>
        {createContact && <AddContact onClose={() => { setCreateContact(false); }} />}
        <Container maxWidth={false}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant='h1'>Contacts</Typography>
                    {isSuperAdmin && <Grid container>
                        <Grid item sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                            <Button size='small' variant='contained' onClick={() => setCreateContact(true)}>Nouveau contact</Button>
                            <TextField
                                size='small'
                                placeholder='Pénom et nom'
                                value={newContactName}
                                onChange={(event) => {
                                    setNewContactName(event.target.value);
                                }}
                                onKeyDown={(e) => (
                                    e.key === 'Enter' && newContactName && !quickCreating && quickCreate()
                                )}
                                InputProps={{
                                    endAdornment: <IconButton color='primary' size='small' disabled={newContactName === '' || quickCreating} onClick={quickCreate}><Add /></IconButton>
                                }}
                            />
                        </Grid>
                    </Grid>}
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ height: 400, width: '100%', backgroundColor: 'white' }}>
                        <DataGrid
                            density='compact'
                            onRowClick={(params, _event) => {
                                navigate('/contact/' + params.row.id);
                            }}
                            rows={contacts}
                            columns={columns}
                        />
                    </Box>
                </Grid>
            </Grid>

        </Container>
    </>;
};
